import SingleUser from './SingleUser';
export default SingleUser;
